import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styled, { createGlobalStyle } from "styled-components";
import { FaUniversalAccess } from "react-icons/fa";


/* ================= GLOBAL ACCESSIBILITY CSS ================= */

const AccessibilityGlobalStyles = createGlobalStyle`

html,
body {
  max-width: 100%;
  overflow-x: hidden !important;
}

#site-content {
  max-width: 100%;
  overflow-x: hidden;
}


/* ניגודיות גבוהה */

#site-content.high-contrast {
  filter: contrast(160%);
}


/* מצב כהה */

#site-content.dark-mode,
#site-content.dark-mode * {
  background-color: #111 !important;
  color: #fff !important;
}

#site-content.dark-mode a {
  color: #66bfff !important;
}


/* גווני אפור */

#site-content.gray-mode {
  filter: grayscale(100%);
}


/* גופן קריא */

#site-content.easy-font,
#site-content.easy-font * {
  font-family: Arial, Tahoma, sans-serif !important;
}


/* ריווח אותיות */

#site-content.letter-space,
#site-content.letter-space * {
  letter-spacing: 3px !important;
}


/* ריווח שורות */

#site-content.line-space,
#site-content.line-space * {
  line-height: 2 !important;
}


/* כתב מודגש */

#site-content.bold-text,
#site-content.bold-text * {
  font-weight: 900 !important;
}


/* טקסט גדול */

#site-content.big-text {
  font-size: 125% !important;
}

#site-content.big-text p,
#site-content.big-text span,
#site-content.big-text li,
#site-content.big-text a,
#site-content.big-text button,
#site-content.big-text input,
#site-content.big-text textarea,
#site-content.big-text label {
  font-size: 1.1em !important;
}


/* הסתרת תמונות */

#site-content.hide-images img,
#site-content.hide-images picture,
#site-content.hide-images video {
  visibility: hidden !important;
}


/* הדגשת קישורים */

#site-content.highlight-links a {
  text-decoration: underline !important;
  color: #0066ff !important;
  font-weight: bold !important;
}


/* ביטול אנימציות */

#site-content.stop-animation *,
#site-content.stop-animation *::before,
#site-content.stop-animation *::after {
  animation: none !important;
  transition: none !important;
  scroll-behavior: auto !important;
}


/* הדגשת כותרות */

#site-content.highlight-headings h1,
#site-content.highlight-headings h2,
#site-content.highlight-headings h3,
#site-content.highlight-headings h4,
#site-content.highlight-headings h5,
#site-content.highlight-headings h6 {
  background: #ffff00 !important;
  color: #000 !important;
  padding: 5px !important;
}


/* סמן גדול */

#site-content.big-cursor,
#site-content.big-cursor *,
#site-content.big-cursor a,
#site-content.big-cursor button,
#site-content.big-cursor input,
#site-content.big-cursor textarea,
#site-content.big-cursor select {
  cursor: zoom-in !important;
}


/* הדגשת פוקוס */

#site-content.read-focus *:focus {
  outline: 4px solid #008cff !important;
  outline-offset: 3px !important;
}


/* מובייל */

@media (max-width: 600px) {

  html,
  body {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden !important;
  }

  #site-content {
    width: 100% !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }

}

`;


/* ================= ACCESSIBILITY BUTTON ================= */

const Button = styled.button`

position:fixed;

left:20px;
bottom:20px;

  width: 60px;
  height: 80px;

  border-radius: 50%;

  border: none;

  background: transparent;

  color: white;

  cursor: pointer;

  z-index: 2147483;

display:flex;

align-items:center;

justify-content:center;

padding:0;

margin:0;

animation:a11yPulse 2s infinite;


svg {

  font-size:70px;

  filter:
    drop-shadow(0 0 6px white)
    drop-shadow(0 0 15px #00c8ff)
    drop-shadow(0 0 30px rgba(0,140,255,.8));

}


@keyframes a11yPulse {

  0% {
    transform:scale(1);
  }

  50% {
    transform:scale(1.08);
  }

  100% {
    transform:scale(1);
  }

}

`;


/* ================= ACCESSIBILITY PANEL ================= */

const Box = styled.div`

position:fixed;

top:0;
left:0;

width:380px;

max-width:100vw;

height:100vh;
height:100dvh;

overflow-y:auto;
overflow-x:hidden;

padding:25px;

box-sizing:border-box;

background:linear-gradient(145deg,#ffffff,#eaf7ff);

color:#111;

z-index:2147483646;

border-right:3px solid #008cff;

box-shadow:5px 0 25px rgba(0,0,0,.25);

transform:${props =>
  props.open
    ? "translateX(0)"
    : "translateX(-110%)"
};

transition:transform .5s ease;

font-family:Arial,Tahoma,sans-serif;


/* כותרת */

.title {

  text-align:center;

  font-size:28px;

  font-weight:900;

  margin-bottom:25px;

  color:#008cff;

  text-shadow:
    0 0 10px #00c8ff,
    0 0 20px rgba(0,140,255,.5);

}


/* סגירה */

.close {

  position:absolute;

  right:20px;
  top:20px;

  width:35px;
  height:35px;

  border-radius:50%;

  border:none;

  background:#ddd;

  color:#111;

  cursor:pointer;

  font-size:18px;

  font-weight:bold;

  display:flex;

  align-items:center;

  justify-content:center;

  padding:0;

}


/* זום */

.zoom {

  text-align:center;

  font-size:20px;

  font-weight:bold;

  margin-bottom:20px;

}


/* כפתורים */

.buttonsGrid {

  display:grid;

  grid-template-columns:repeat(2,1fr);

  gap:12px;

}


.buttonsGrid button {

  min-height:60px;

  border:none;

  border-radius:14px;

  background:#ffffff;

  color:#003b80;

  font-size:15px !important;

  font-weight:800;

  cursor:pointer;

  border:1px solid #ccc;

  transition:background .2s, transform .15s;

  padding:10px;

}


.buttonsGrid button:hover {

  background:#e8f4ff;

  transform:translateY(-1px);

}


.buttonsGrid button.active {

  background:#008cff !important;

  color:white !important;

  box-shadow:0 0 10px #00c8ff;

}


.buttonsGrid button:focus,
.close:focus {

  outline:3px solid #003b80;

  outline-offset:2px;

}


/* מובייל */

@media(max-width:600px) {

  width:80vw;

  max-width:80vw;

  padding:20px;


  .buttonsGrid {

    grid-template-columns:1fr;

  }


  .title {

    font-size:28px;

  }

}

`;


/* ================= COMPONENT ================= */

export default function AccessibilityWidget() {

  const [open, setOpen] = useState(false);

  const [zoom, setZoom] = useState(100);

  const [fontSize, setFontSize] = useState(100);

  const [active, setActive] = useState({});

  const speechRef = useRef(null);


  /* ================= SITE ================= */

  const getSite = () => {

    return document.getElementById("site-content");

  };


  /* ================= STORAGE ================= */

  const getSavedSettings = () => {

    try {

      return JSON.parse(
        localStorage.getItem("a11ySettings") || "{}"
      );

    } catch {

      return {};

    }

  };


  const saveSettings = (data) => {

    const old = getSavedSettings();

    localStorage.setItem(
      "a11ySettings",
      JSON.stringify({
        ...old,
        ...data
      })
    );

  };


  /* ================= ZOOM ================= */

  const applyZoom = (value) => {

    const site = getSite();

    if (!site) return;


    site.style.removeProperty("transform");

    site.style.removeProperty("width");

    site.style.removeProperty("transform-origin");


    if (value === 100) {

      return;

    }


    const scale = value / 100;


    /*
      שימוש ב-transform בלבד.
      לא משנים width כדי למנוע
      בריחה לצד ימין במובייל.
    */

    site.style.transformOrigin = "top center";

    site.style.transform =
      `scale(${scale})`;

  };


  /* ================= LOAD SETTINGS ================= */

  useEffect(() => {

    const site = getSite();

    if (!site) return;


    const saved = getSavedSettings();


    /* זום */

    if (
      typeof saved.zoom === "number"
    ) {

      setZoom(saved.zoom);

      applyZoom(saved.zoom);

    }


    /* גודל כתב */

    if (
      typeof saved.fontSize === "number"
    ) {

      setFontSize(saved.fontSize);

      site.style.fontSize =
        saved.fontSize + "%";

    }


    /* אפשרויות */

    Object.keys(saved).forEach(key => {

      if (
        saved[key] === true &&
        key !== "zoom" &&
        key !== "fontSize"
      ) {

        site.classList.add(key);

      }

    });


    setActive(saved);

  }, []);


  /* ================= ZOOM ================= */

  const changeZoom = (num) => {

    let value = zoom + num;


    if (value < 80) {

      value = 80;

    }


    if (value > 160) {

      value = 160;

    }


    setZoom(value);

    applyZoom(value);

    saveSettings({
      zoom:value
    });

  };


  /* ================= RESET ZOOM ================= */

  const resetZoom = () => {

    setZoom(100);

    applyZoom(100);

    saveSettings({
      zoom:100
    });

  };


  /* ================= FONT SIZE ================= */

  const changeFontSize = (value) => {

    const site = getSite();

    if (!site) return;


    if (value < 90) {

      value = 90;

    }


    if (value > 170) {

      value = 170;

    }


    site.style.fontSize =
      value + "%";


    setFontSize(value);


    saveSettings({
      fontSize:value
    });

  };


  /* ================= TOGGLE ================= */

  const toggle = (name) => {

    const site = getSite();

    if (!site) return;


    const enabled =
      !site.classList.contains(name);


    site.classList.toggle(name);


    setActive(prev => ({
      ...prev,
      [name]:enabled
    }));


    saveSettings({
      [name]:enabled
    });

  };


  /* ================= SPEECH ================= */

  const readPage = () => {

    if (!window.speechSynthesis) {

      return;

    }


    window.speechSynthesis.cancel();


    const site = getSite();

    if (!site) return;


    const text = site.innerText;

    if (!text) return;


    const speech =
      new SpeechSynthesisUtterance(text);


    speech.lang = "he-IL";

    speech.rate = 1;


    speechRef.current = speech;


    window.speechSynthesis.speak(
      speech
    );

  };


  /* ================= STOP SPEECH ================= */

  const stopReading = () => {

    if (window.speechSynthesis) {

      window.speechSynthesis.cancel();

    }

  };


  /* ================= RESET ================= */

  const reset = () => {

    const site = getSite();


    if (site) {

      const classes = [

        "high-contrast",

        "dark-mode",

        "gray-mode",

        "easy-font",

        "letter-space",

        "line-space",

        "bold-text",

        "big-text",

        "hide-images",

        "highlight-links",

        "stop-animation",

        "highlight-headings",

        "big-cursor",

        "read-focus"

      ];


      classes.forEach(className => {

        site.classList.remove(
          className
        );

      });


      site.style.removeProperty(
        "transform"
      );

      site.style.removeProperty(
        "width"
      );

      site.style.removeProperty(
        "font-size"
      );

      site.style.removeProperty(
        "transform-origin"
      );

    }


    stopReading();


    localStorage.removeItem(
      "a11ySettings"
    );


    setZoom(100);

    setFontSize(100);

    setActive({});

  };


  /* ================= UI ================= */

  return createPortal(

    <>

      <AccessibilityGlobalStyles />


      {!open && (

        <Button
          type="button"
          aria-label="פתיחת תפריט נגישות"
          title="נגישות"
          onClick={() => setOpen(true)}
        >

          <FaUniversalAccess />

        </Button>

      )}


      <Box
        open={open}
        id="a11y-panel"
        role="dialog"
        aria-label="תפריט נגישות"
        aria-modal="false"
      >

        <div className="title">
          נגישות
        </div>


        <button
          type="button"
          className="close"
          aria-label="סגירת תפריט נגישות"
          onClick={() => setOpen(false)}
        >
          ✕
        </button>


        <div className="zoom">
          🔍 זום {zoom}%
        </div>


        <div className="buttonsGrid">


          <button
            type="button"
            onClick={() => changeZoom(10)}
          >
            🔍 הגדלת מסך
          </button>


          <button
            type="button"
            onClick={() => changeZoom(-10)}
          >
            🔎 הקטנת מסך
          </button>


          <button
            type="button"
            onClick={resetZoom}
          >
            ↩ איפוס זום
          </button>


          <button
            type="button"
            onClick={() =>
              changeFontSize(fontSize + 10)
            }
          >
            🔠 הגדלת כתב
          </button>


          <button
            type="button"
            onClick={() =>
              changeFontSize(fontSize - 10)
            }
          >
            🔡 הקטנת כתב
          </button>


          <button
            type="button"
            className={
              active["high-contrast"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("high-contrast")
            }
          >
            ⚫ ניגודיות גבוהה
          </button>


          <button
            type="button"
            className={
              active["dark-mode"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("dark-mode")
            }
          >
            🌙 מצב כהה
          </button>


          <button
            type="button"
            className={
              active["gray-mode"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("gray-mode")
            }
          >
            ⚪ גווני אפור
          </button>


          <button
            type="button"
            className={
              active["easy-font"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("easy-font")
            }
          >
            📖 גופן קריא
          </button>


          <button
            type="button"
            className={
              active["bold-text"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("bold-text")
            }
          >
            🅱 כתב מודגש
          </button>


          <button
            type="button"
            className={
              active["big-text"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("big-text")
            }
          >
            🔠 טקסט גדול
          </button>


          <button
            type="button"
            className={
              active["hide-images"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("hide-images")
            }
          >
            🖼 הסתרת תמונות
          </button>


          <button
            type="button"
            className={
              active["highlight-links"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("highlight-links")
            }
          >
            🔗 קו תחתון לקישורים
          </button>


          <button
            type="button"
            className={
              active["stop-animation"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("stop-animation")
            }
          >
            ⏸ ביטול אנימציות
          </button>


          <button
            type="button"
            className={
              active["highlight-headings"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("highlight-headings")
            }
          >
            🟨 הדגשת כותרות
          </button>


          <button
            type="button"
            className={
              active["big-cursor"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("big-cursor")
            }
          >
            🖱 סמן גדול
          </button>


          <button
            type="button"
            className={
              active["letter-space"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("letter-space")
            }
          >
            ↔ ריווח אותיות
          </button>


          <button
            type="button"
            className={
              active["line-space"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("line-space")
            }
          >
            ↕ ריווח שורות
          </button>


          <button
            type="button"
            className={
              active["read-focus"]
                ? "active"
                : ""
            }
            onClick={() =>
              toggle("read-focus")
            }
          >
            🎯 הדגשת פוקוס
          </button>


          <button
            type="button"
            onClick={readPage}
          >
            🔊 הקראת טקסט
          </button>


          <button
            type="button"
            onClick={stopReading}
          >
            ⏹ עצירת הקראה
          </button>


          <button
            type="button"
            onClick={reset}
          >
            ♻ איפוס הכל
          </button>


        </div>

      </Box>

    </>,

    document.body

  );

}